import React from "react";

function TeachersInfo({ data }) {

  return (
    <div className="card cutumBorder cardSingle m-3 d-flex flex-column text-center p-4"
    >
      <div
        id="carouselExampleControls"
        className="carousel slide"
        data-ride="carousel"
      >
        <div className="carousel-inner">
          {data &&
            data.teachers &&
            data.teachers.map((teach, i) => {
              return (
                <div
                  key={i}
                  className={`carousel-item ${i === 0 ? "active" : ""
                    }`}
                >
                  <img
                    className="card-img-top teacherImgSingle"
                    src={teach.image[0]}
                    alt={`${i}مربی`}
                  />
                  <div className="d-flex flex-column align-items-center mt-2 ">
                    <h5>{teach.name}</h5>
                    <hr
                      style={{
                        width: "80%",
                      }}
                      className="my-2"
                    />
                    <span>{teach.proof}</span>
                    <span>{teach.destails}</span>
                    <span>{teach.activity}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default TeachersInfo;
